/**
 * Responsibility: name a grade bucket for a reader.
 *
 * Its own module because three files need it - the outlier table, its
 * controls and the page - and a component file that also exports a
 * function breaks fast refresh.
 *
 * A bucket is now "RAW" or a grader and a number: "PSA 10", "CGC 9.5".
 * The grader is in it because a CGC 10 and a PSA 10 are different cards
 * at different prices, and a bucket of "10" that mixed them was reading
 * an $600 CGC slab as an 87% discount on a $4,855 PSA market.
 *
 * "RAW" is the hub's word for ungraded. It is spelled out here rather
 * than shown raw, because a column reading RAW in capitals next to
 * "PSA 10" looks like a different kind of thing than it is.
 */
export function gradeBucketLabel(bucket: string): string {
  return bucket === 'RAW' ? 'Raw' : bucket;
}

/**
 * Buckets in reading order: raw first, then by grader, then by grade
 * descending - so PSA 10 sits above PSA 8 rather than below it, which
 * is what a string sort does.
 */
export function sortBuckets(buckets: string[]): string[] {
  return [...buckets].sort((left, right) => {
    if (left === 'RAW') return -1;
    if (right === 'RAW') return 1;
    const [leftCompany = '', leftGrade = ''] = left.split(' ');
    const [rightCompany = '', rightGrade = ''] = right.split(' ');
    if (leftCompany !== rightCompany) return leftCompany.localeCompare(rightCompany);
    return Number(rightGrade) - Number(leftGrade);
  });
}
